(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slider')) {
    class BannerSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.slides.length < 2) return;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.sync(), 80);
        }, { passive: true });

        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); this.restart(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); this.restart(); }
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.track.addEventListener('touchstart', () => this.stop(), { passive: true });
        this.track.addEventListener('touchend', () => this.start(), { passive: true });

        this.initDrag();

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.editing = true; this.stop(); this.go(i, true); }
        };
        this.onBlockDeselect = (e) => {
          if (this.slides.indexOf(e.target) > -1) { this.editing = false; this.start(); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i, instant) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.track.scrollTo({
          left: this.slides[this.index].offsetLeft,
          behavior: instant || this.reduced ? 'auto' : 'smooth'
        });
        this.update();
      }

      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
        if (i !== this.index) { this.index = i; this.update(); }
      }

      update() {
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
          const link = slide.querySelector('a');
          if (link) { if (active) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); }
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.reduced || this.editing || this.slides.length < 2) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() { clearInterval(this.timer); }
      restart() { this.stop(); if (!this.matches(':hover')) this.start(); }

      initDrag() {
        const t = this.track;
        let down = false, moved = false, startX = 0, startLeft = 0;

        t.addEventListener('dragstart', (e) => e.preventDefault());

        t.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; moved = false;
          startX = e.clientX; startLeft = t.scrollLeft;
        });

        t.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true;
            t.classList.add('is-dragging');
            try { t.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (moved) t.scrollLeft = startLeft - dx;
        });

        const end = (e) => {
          if (!down) return;
          down = false;
          if (!moved) return;
          const w = t.clientWidth || 1;
          const dx = e.clientX - startX;
          const from = Math.round(startLeft / w);
          let target = from;
          if (dx < -w * 0.08) target = from + 1;
          else if (dx > w * 0.08) target = from - 1;
          target = Math.max(0, Math.min(this.slides.length - 1, target));
          t.classList.remove('is-dragging');
          this.go(target);
          this.justDragged = true;
          setTimeout(() => { this.justDragged = false; }, 50);
        };
        t.addEventListener('pointerup', end);
        t.addEventListener('pointercancel', end);

        t.addEventListener('click', (e) => {
          if (this.justDragged) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }
    }
    customElements.define('banner-slider', BannerSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
